<template>
    <div>
        <tsoft-table
            name="finance-virtual"
            :key="componentRefreshKey"
            :api="tableApiUrl"
            :items.sync="items"
            :isNeedSearch="true"
            :additionalGetParameter="additionalGetParameter"
            :isNeedCreate="isNeedCreate"
            :typeOfTableFilter="typeOfTableFilter"
            :onDataEmptyMessage="'Виртуальные счета отсутствуют. Добавьте новый счет.'"
            @show="showItem"
            @edit="createOrEditItemModal"
            @delete="deleteItem"
        />

        <b-overlay
            :show="dataOverlay"
            spinner-variant="success"
            no-wrap
        ></b-overlay>

        <div class="mt-3 text-right">
            <div>
                <b>Виртуальных счетов на сумму:</b> {{ virtualSum | toCurrency }} руб.
            </div>
            <div>
                <b>Маржинальная прибыль:</b> {{ marginSum | toCurrency }} руб.
            </div>
            <div v-if="marginSumArr && marginSumArr.length > 0">
                <em>Маржинальная прибыль строится из сумм:</em>
                <ul style="font-size: 12px; line-height: 13px;">
                    <li v-for="item in marginSumArr">
                        {{ item.invoice_number || 'б/н' }}: {{ item.marginSum | toCurrency }} руб. (до налога: {{ item.sum | toCurrency }}<span v-if="item.commission_bank && item.commission_bank > 0">, комиссия банка: {{ item.commission_bank | toCurrency }}</span>)
                    </li>
                </ul>
            </div>
        </div>

        <b-sidebar
            v-if="isSidebarOpen"
            v-model="isSidebarOpen"
            id="sidebar-right-create-or-edit-finance-virtual"
            right
            backdrop
            shadow
            width="80%"
            backdrop-variant="dark"
            ref="editItem"
            no-close-on-backdrop
            @change="closeSidePanelCallback()"
        >
            <template #title>
                <div>
                    <strong id="sidebar-right___title__" v-html="modalTitle()"></strong>
                </div>
            </template>
            <div class="d-block">
                <div v-if="financeOfOrder.length === 0 && !loading">
                    <div class="alert alert-danger" role="alert">
                        У данного заказа нет счетов «Покупателю».<br>
                        Добавьте хотя бы один счет, после этого попробуйте снова.
                    </div>
                </div>
                <form class="needs-validation mb-4" novalidate id="financeVirtualForm" v-if="financeOfOrder.length > 0">
                    <div class="form-row">
                        <div class="form-group col-md-8">
                            <b-form-group 
                                label="Счет из которого будет вычитаться виртуальный счет" 
                                v-slot="{ ariaDescribedby }"
                            >
                                <b-form-radio 
                                    v-model="editedItem.finance_id" 
                                    v-for="finance in financeOfOrder"
                                    :disabled="finance.sum <= 0"
                                    :aria-describedby="ariaDescribedby" 
                                    :name="`finance-radios-${finance.id}`" 
                                    :value="finance.id"
                                    :key="finance.id"
                                >
                                    {{ finance.invoice_number || finance.id }} - {{ finance.sum | toCurrency }} руб.
                                </b-form-radio>
                            </b-form-group>
                        </div>
                        <div class="form-group col-md-8">
                            <label>Тип услуги на которую создается виртуальный счет</label>
                            <b-form-select 
                                v-model="editedItem.reference_service_id" 
                                required
                                :options="optionsOfService" 
                            ></b-form-select>
                        </div>
						<div class="form-group col-md-12">
							<div class="form-row">
								<div class="form-group col-md-5">
									<div class="mb-2">
										<label>Отдел, к которому привязывается счет</label>
										<b-form-select 
											v-model="editedItem.departament_id" 
											required
											:options="optionsOfOtdel" 
										></b-form-select>
									</div>
									<div>
										<label>Сотрудник, в пользу которого зачисляется счет</label>
										<multiselect
											key="selection_user_id"
											v-model="choiceManager"
											class="finance-virtuals"
											:options="managers"
											:searchable="false"
											:close-on-select="false"
											:show-labels="false"
											:multiple="false"
											required
											label="text"
											track-by="value"
											placeholder="Нажмите, чтобы выбрать..."
										></multiselect>
									</div>
								</div>
								<div class="form-group col-md-7">
									<div class="mb-2">
										<label>Дополнительный отдел, к которому привязывается счет</label>
										<b-form-select 
											v-model="editedItem.departament_id_add_1" 
											:options="optionsOfOtdel" 
										></b-form-select>
									</div>
									<div>
										<label>Дополнительный сотрудник, в пользу которого зачисляется счет (если необходимо)</label>
										<multiselect
											key="selection_user_id_add_1"
											v-model="choiceManagerAdd1"
											class="finance-virtuals"
											:options="managersAdd1"
											:searchable="false"
											:close-on-select="false"
											:show-labels="false"
											:multiple="false"
											label="text"
											track-by="value"
											placeholder="Нажмите, чтобы выбрать..."
										></multiselect>													
									</div>
								</div>
				
							</div>
						</div>
						
                        <div class="form-group col-md-8">
                            <label>Сумма в рублях, которую необходимо зачесть в выбранный отдел</label>
                            <b-form-input
                                required
                                id="sum_payment"
                                type="text"
                                size="sm"
                                v-model="editedItem.sum"
                                @keyup="changeCommasOnDots($event)"
                                @change="checkEnteredSumValidity()"
                            ></b-form-input>
                        </div>
                        <div class="form-group col-md-8">
                            <label for="comment">Комментарий к счету</label>
                            <b-form-textarea
                              id="textarea-comment"
                              placeholder="Оставьте комментарий к счету, если хотите оставить какую-либо пометку."
                              rows="5"
                              max-rows="8"
                              v-model="editedItem.comment"
                            ></b-form-textarea>
                        </div>
                    </div>
                </form>
            </div>
            <template #footer>
                <div class="row align-items-center">
                    <div class="col d-flex flex-row-reverse">
                        <button
                            v-if="financeOfOrder.length > 0" 
                            class="btn btn-primary text-right" 
                            type="submit" 
                            @click="submitForm($event)"
                        >Сохранить<i class="fas fa-spinner fa-spin ml-1" v-if="savingProcess"></i></button>
                        <button
                            v-if="!savingProcess"
                            class="btn btn-secondary text-right mr-2" 
                            @click="isSidebarOpen=false"
                        >Закрыть</button>
                    </div>
                </div>
            </template>
        </b-sidebar>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import {API_USERS, API_FINANCE_VIRTUALS, API_FINANCE} from "../../constants"
    import debounce from "../../services/helpers";

    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
        changeCommasOnDots,
        toCurrency
    } from '../../mixins'

    const initialEditedItem = () => ({
        id: '',
        user_id: '',
		user_id_add_1: null,
        creator_user_id: '',
        order_id: '',
        reference_service_id: 23,
        finance_id: '',
        departament_id: 3,
		departament_id_add_1: null,
        sum: '',
        user: {},
		user_add_1: {},
        user_creator: {},
        order: {},
        service: {},
        finance: {},
        departament: {},
		departament_add_1: {},
        comment: ''
    })

    export default {
        components: {
        },
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionCreateOrUpdateItem,
            actionDeleteItem,
            changeCommasOnDots,
        ],
        props: {
            order_id: { type: Number|String, required: true },
            isNeedCreate: { type: Boolean, required: false, default: true },        // If table needs create new element button
            additionalGetParameter: { type: String, required: false, default: '' }, // If we want to add something, for example, &order_id=10
            typeOfTableFilter: { type: String, required: false, default: '' },      // Type of filter for output: orders, services
        },
        data() {
            return {
                loading: false,
                tableApiUrl: API_FINANCE_VIRTUALS,
                componentRefreshKey: 0,
                optionsOfOtdel: [
                    { value: 2, text: 'Отдел ВЭД' },
                    { value: 3, text: 'Отдел логистики' },
                    // { value: 1, text: 'Отдел продаж' },
                    { value: 6, text: 'Руководство компании' },
                ],
                optionsOfService: [
                    { value: 22, text: 'ТО' },
                    { value: 23, text: 'Логистика' },
                    { value: 24, text: 'Сертификация' },
                    { value: 25, text: 'Консалтинг' },
                    { value: 75, text: 'ПНК' },
                    { value: 76, text: 'СВХ' },
                    { value: 77, text: 'Страхование' },
                ],
                financeOfOrder: [],
                choiceManager: null,
				choiceManagerAdd1: null,
                managers: [],
				managersAdd1: [],
                marginSum: 0,
                marginSumArr: [],
                virtualSum: 0,
                dataOverlay: false
            }
        },
        watch: {
            'editedItem.finance_id': function(newVal, oldVal) {
                this.checkEnteredSumValidity();
            },
            'editedItem.departament_id': function(newVal, oldVal) {
                this.getUsers();
            },
			'editedItem.departament_id_add_1': function(newVal, oldVal) {
                this.getUsers('managersAdd1', 'departament_id_add_1');
            },
            'editedItem.user_id': function(newVal, oldVal) {
                if ((newVal && this.choiceManager && newVal != this.choiceManager.value) || newVal && !this.choiceManager) {
                    this.setChoiceManager();
                }
            },
			'editedItem.user_id_add_1': function(newVal, oldVal) {
                if ((newVal && this.choiceManagerAdd1 && newVal != this.choiceManagerAdd1.value) || newVal && !this.choiceManagerAdd1) {
                    this.setChoiceManagerAdd1();
                }
            },
            items: {
                deep: true,
                handler(virtualFinance) {
                    this.virtualSum = 0;

                    if (virtualFinance && virtualFinance.data) {
                        virtualFinance.data.every((finance) => {
                            this.virtualSum = this.virtualSum + finance.sum;

                            return true;
                        })
                    }

                    this.virtualSum = Number(this.virtualSum.toFixed(2));
                },
            }, 
        },
        mounted() {
            this.editedItem = initialEditedItem();
            this.initialAssign();
            this.getUsers();
        },
        methods: {
            getDefaultNds() {
                // С 2026 года используется НДС 22%, до этого - 20%
                const currentYear = new Date().getFullYear();
                return currentYear >= 2026 ? 22 : 20;
            },

            initialAssign() {
                this.editedItem.order_id = this.order_id;
                this.loadAllFinanceOperations();
                this.setChoiceManager(true);
				this.setChoiceManagerAdd1(true);
            },
            async getUsers(managersKey = 'managers', depKey = 'departament_id') {
                let roles = '';

                switch (this.editedItem[depKey]) {
                    // case 1:
                    //     roles = "sales-manager||sales-head-manager";
                    //     break;
                    case 2:
                        roles = "TO-manager||TO-head-manager";
                        break;
                    case 3:
                        roles = "logistics-manager||logistics-head-manager";
                        break;
                    case 8:
                        roles = "logistics-multim-manager||logistics-multim-head-manager";
                        break;
                    // case 9:
                    //     roles = "b2c-head-manager||b2c-manager";
                    //     break;
                    // case 10:
                    //     roles = "bsz-manager";
                    //     break;
                    case 6:
                        roles = "president";
                        break;
                    default:
                        roles = "";
                        break;
                }

                await axios
                    .get(API_USERS, {
                    params: {
                        roles: roles,
                        withoutFired: true
                    },
                    })
                    .then(({ data }) => {
                        if (data.data) {
                            data = data.data;
                        }

                        // Проверяем, что data является массивом
                        if (Array.isArray(data)) {
                            data.sort((a, b) => {
                                if (a.fired_text === "Да" && b.fired_text !== "Да") {
                                    return 1;  // a should appear after b
                                } else if (b.fired_text === "Да" && a.fired_text !== "Да") {
                                    return -1;  // b should appear after a
                                }
                                // Безопасная сортировка по text с проверкой на существование
                                const aText = (a.text || '').toString();
                                const bText = (b.text || '').toString();
                                return aText.localeCompare(bText);  // sort by the 'text' field in ascending order
                            });
                            this[managersKey] = data;
                        } else {
                            this[managersKey] = [];
                        }
                    });
            },
            setChoiceManager(makeNull = false) {
                if (makeNull) {
                    this.choiceManager = null;
                    return;
                }

                this.choiceManager = {
                    value: this.editedItem.user_id,
                    text: this.editedItem.user.name,
                };
            },
			setChoiceManagerAdd1(makeNull = false) {
                if (makeNull) {
                    this.choiceManagerAdd1 = null;
                    return;
                }

                this.choiceManagerAdd1 = {
                    value: this.editedItem.user_id_add_1,
                    text: this.editedItem.user_add_1.name,
                };
            },
            loadAllFinanceOperations() {
                this.loading = true;
                this.financeOfOrder = [];
                this.marginSum = 0;
                this.marginSumArr = [];

                axios.get(API_FINANCE + '?per_page=250&order_id=' + this.order_id).then(response => {
                    this.loading = false;
                    // Проверяем структуру ответа: может быть массив напрямую или обернутый в объект
                    let allFinance = Array.isArray(response.data) ? response.data : (response.data.data || []);
                    
                    if (!Array.isArray(allFinance)) {
                        allFinance = [];
                    }
                    
                    allFinance.every((finance, index) => {
                        let calcedSum = this.countFinalSum(finance);

                        if (finance.invoice_type == 'incoming') {
                            const item = {
                                type: 'incoming',
                                invoice_number: finance.invoice_number,
                                sum: Number(finance.sum_payment),
                                marginSum: calcedSum,
                                commission_bank: parseFloat(finance.commission_bank || 0)
                            };
                            this.marginSumArr.push(item);

                            this.marginSum = this.marginSum + calcedSum;
                            this.financeOfOrder.push(finance);

                            if (finance.sum > 0 && !this.editedItem.finance_id) {
                                this.editedItem.finance_id = finance.id;
                            }

                        } else {
                            const item = {
                                type: 'outgoing',
                                invoice_number: finance.invoice_number,
                                sum: Number(finance.sum_payment),
                                marginSum: -calcedSum,
                                commission_bank: parseFloat(finance.commission_bank || 0)
                            };
                            this.marginSumArr.push(item);

                            this.marginSum = this.marginSum - calcedSum;
                        }

                        return true;
                    })

                    this.marginSum = Number(this.marginSum.toFixed(2));
                }).catch(error => {
                    this.loading = false;
                })
            },
            // calls from mixin before sidebaropened
            beforeSidebarOpenedCallback() {
                this.editedItem = initialEditedItem();
                this.initialAssign();
            },
            // calls from mixin on item save
            onCreatedOrUpdatedCallback() {
                this.isSidebarOpen = false
            },
            submitForm(event) {
                event.preventDefault()
                let form = document.getElementById("financeVirtualForm")
                if (form.checkValidity() === false) {
                    event.preventDefault()
                    event.stopPropagation()
                    form.classList.add('was-validated')
                    return false
                }

                this.editedItem.user_id = this.choiceManager.value;
                this.editedItem.user_id_add_1 = this.choiceManagerAdd1 ? this.choiceManagerAdd1.value : null;
                this.createOrUpdateItem()
            },
            onDeletedCallback() {
                this.componentRefreshKey++
                this.updateParentData()
            },
            checkEnteredSumValidity() {
                let selectedFinanceSum = 0;

                this.financeOfOrder.every((finance) => {
                    if (finance.id === this.editedItem.finance_id) {
                        selectedFinanceSum = finance.sum;
                        return false;
                    }

                    return true;
                })

                if (this.editedItem.sum > selectedFinanceSum) {
                    this.editedItem.sum = selectedFinanceSum;
                }
            },
            countFinalSum(finance) {
                let sum = Number(finance.sum_payment);

                // IF IP BORODINA - NO NDS
                if (finance.external_company_id == 2 || finance.company_id == 2 || finance.natural == 1) {
                    return sum;
                }

                if (finance.zero_rate != 1) {
                    if (finance.with_nds == 1) {
                        // sum = sum / 1.2;
                        let nds_percent = finance.size_nds ? finance.size_nds : this.getDefaultNds(); // Используем размер НДС из данных или дефолтное значение
				        sum = sum / (1 + nds_percent / 100);
                    }
                }

                let commissionBank = parseFloat(finance.commission_bank || 0);
                if (commissionBank > 0) {
                    sum -= commissionBank;
                }

                return sum;
            },
            modalTitle() {
                let title = 'Добавление счёта для поставки #' + this.order_id
                if (this.editIndex > -1) {
                    title = 'Редактирование счёта #' + this.editedItem.id
                }

                return title
            },
            updateParentData() {
                this.$emit("updateParentData")
            }
        }
    }
</script>
